import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgData = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "data-icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .secc10 {\n        fill: #0573A9;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "secc10",
			d: "M11.5,13.1H2.5c-1.1,0-2-.9-2-2V2.1C.5,1,1.4.1,2.5.1h9c1.1,0,2,.9,2,2v9c0,1.1-.9,2-2,2M2.5,1.2c-.5,0-.9.4-.9.9h0v9c0,.5.4.9.9.9h9c.5,0,.9-.4.9-.9V2.1c0-.5-.4-.9-.9-.9H2.5Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "secc10",
			x: 3.1,
			y: 2.7,
			width: 3.3,
			height: 3.3
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "secc10",
			x: 3.1,
			y: 7.2,
			width: 3.3,
			height: 3.3
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "secc10",
			x: 7.6,
			y: 2.7,
			width: 3.3,
			height: 3.3
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "secc10",
			x: 7.6,
			y: 7.2,
			width: 3.3,
			height: 3.3
		})
	]
});
export default SvgData;
